import React from 'react'
import PublicProfileImageModal from './PublicProfileImageModal'
import PublicProfileActionSheet, { PublicProfileActionSheetRef } from './PublicProfileActionSheet'
import { ReportUserModal } from '../ui/ReportUserModal'

type PublicProfileModalsProps = {
  showImageModal: boolean
  showReportModal: boolean
  user: any
  currentUser: any
  actionSheetRef: React.RefObject<PublicProfileActionSheetRef>
  isOwnProfile: boolean
  imageUrl?: string
  onCloseImageModal: () => void
  onCloseReportModal: () => void
  onReportUser: () => void | Promise<void>
  onReportSuccess: () => void
  onBlockUser: () => void | Promise<void>
  canReport?: boolean
}

export default function PublicProfileModals(props: PublicProfileModalsProps) {
  const { 
    showImageModal, 
    showReportModal,
    imageUrl, 
    onCloseImageModal, 
    onCloseReportModal,
    onReportSuccess,
    isOwnProfile, 
    actionSheetRef, 
    user, 
    currentUser,
    onReportUser,
    onBlockUser,
    canReport = true,
  } = props
  
  const reportedUserUuid = user?.uuid || user?.id || ''
  const reportedByUuid = currentUser?.uuid || ''
  
  return (
    <>
      <PublicProfileImageModal visible={!!showImageModal} imageUrl={imageUrl} onClose={onCloseImageModal} />
      {!isOwnProfile ? (
        <>
          <PublicProfileActionSheet
            ref={actionSheetRef}
            userName={user?.displayName || 'User'}
            onReportUser={onReportUser}
            onBlockUser={onBlockUser}
            canReport={canReport}
          />
          {reportedUserUuid && reportedByUuid && (
            <ReportUserModal
              visible={showReportModal}
              onClose={onCloseReportModal}
              reportedUserUuid={reportedUserUuid}
              reportedByUuid={reportedByUuid}
              onSuccess={onReportSuccess}
            />
          )}
        </>
      ) : null}
    </>
  )
}


